import React, { memo } from "react";
import CardServiceDesktop from "components/Cards/CardServiceDesktop";

const HomeServicesDesktop = ({ services }) => {
  return (
    <div className="">
      <div className="block md:flex">
        {services?.items
          .filter((item) => item.homepage_highlighted == true)
          .map((item, index) => {
            return (
              <div className="w-full md:w-1/4" key={index}>
                <CardServiceDesktop data={item} />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default memo(HomeServicesDesktop);
